module.exports = __webpack_public_path__ + "img/yiban.e58d4e64.png";